import page from "./_Layout/_Layout";

export default page;
